import axios from 'axios'

export const LOGIN_PATH = '/yttynnttdsht0268ws0501pls'
export const SESSION_CHECK_INTERVAL_MS = 60 * 1000

const SESSION_EXPIRY_CODES = new Set([
    'AUTHENTICATION_REQUIRED',
    'SECOND_FACTOR_REQUIRED',
    'QUALITY_REVIEW_SECOND_FACTOR_REQUIRED'
])

export function isSessionExpiryError(error) {
    const status = Number(error?.response?.status || 0)
    const code = String(error?.response?.data?.code || '')

    if (status === 401) return code === 'AUTHENTICATION_REQUIRED'
    if (status === 403) return SESSION_EXPIRY_CODES.has(code)
    return false
}

export function hasVerifiedSession(user) {
    return Boolean(user?._id && user?.secondFactorVerified === true)
}

export function createLoginRedirect(windowObject = window) {
    let redirectStarted = false

    return () => {
        try {
            windowObject.sessionStorage?.removeItem('verified2FA')
        } catch (error) {
            // Storage can be unavailable in locked-down browsers; navigation must still work.
        }

        if (redirectStarted || windowObject.location?.pathname === LOGIN_PATH) return false
        redirectStarted = true
        windowObject.location.replace(LOGIN_PATH)
        return true
    }
}

export const redirectToLogin = createLoginRedirect()

export function installSessionExpiryInterceptor(axiosClient = axios, onExpired = redirectToLogin) {
    return axiosClient.interceptors.response.use(
        response => response,
        error => {
            if (isSessionExpiryError(error)) onExpired()
            return Promise.reject(error)
        }
    )
}

export async function bootstrapProtectedSession({ fetchUser, fetchRoles, onUnauthenticated = redirectToLogin }) {
    const user = await fetchUser()

    if (!hasVerifiedSession(user)) {
        onUnauthenticated()
        return { authenticated: false, user }
    }

    await fetchRoles()
    return { authenticated: true, user }
}

export function startSessionMonitor(checkSession, {
    windowObject = window,
    documentObject = document,
    intervalMs = SESSION_CHECK_INTERVAL_MS
} = {}) {
    let activeCheck = null

    const runCheck = () => {
        if (activeCheck) return activeCheck
        activeCheck = Promise.resolve()
            .then(checkSession)
            .catch(() => {})
            .finally(() => {
                activeCheck = null
            })
        return activeCheck
    }

    const handleFocus = () => runCheck()
    const handleVisibilityChange = () => {
        if (documentObject.visibilityState === 'visible') return runCheck()
        return undefined
    }
    const intervalId = windowObject.setInterval(runCheck, intervalMs)

    windowObject.addEventListener('focus', handleFocus)
    documentObject.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
        windowObject.clearInterval(intervalId)
        windowObject.removeEventListener('focus', handleFocus)
        documentObject.removeEventListener('visibilitychange', handleVisibilityChange)
    }
}
